import { render, staticRenderFns } from "./TipiProdotto.vue?vue&type=template&id=901cc21e&"
import script from "./TipiProdotto.vue?vue&type=script&lang=js&"
export * from "./TipiProdotto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports